import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Getintouch from '../layouts/Getintouch';

const Aboutleads = () => {

    const settings = {
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        fade: false,
        speed: 600
    };
    return (
        <>
            <Header />
            <Link class="back-button" to={"/Service"}><i class="fa-solid fa-arrow-left"></i>Back</Link>
            <section>
                <div className="text">
                    <h2 className="text-h2">
                        Where creativity meets <br /> conversion
                    </h2>
                    <p className="text-p">
                        Strategic marketing that delivers measurable growth <br />
                        Fuel your business with data-driven digital campaigns
                    </p>
                </div>
            </section>

            <div className="slider-animation">
                <Slider {...settings}>
                    {/* Slide 1 */}
                    <div className="slide-content">
                        <div className="slide-bg" style={{ backgroundImage: "url('./images/Mask group.png')" }}></div>
                        <div className="content-wrapper">
                            <div className="content-inner">
                                <img src={process.env.PUBLIC_URL +"/images/slide1-icon1.png"} className="icon icon1" alt="" />
                                <img src={process.env.PUBLIC_URL + "/images/slide1-icon2.png"} className="icon icon2" alt="" />
                                <img src={process.env.PUBLIC_URL +"/images/slide1-icon3.png"} className="icon icon3" alt="" />
                                <img src={process.env.PUBLIC_URL +"/images/slide1-icon4.png"} className="icon icon4" alt="" />
                                <img src={process.env.PUBLIC_URL +"/images/slide1-icon5.png"} className="icon icon5" alt="" />
                                <img src={process.env.PUBLIC_URL +"/images/slide1-icon6.png"} className="icon icon6" alt="" />
                                <img src={process.env.PUBLIC_URL + "/images/slide1-icon7.png"} className="icon icon7" alt="" />
                                <img src={process.env.PUBLIC_URL + "/images/phone.png"} alt="Phone" className="phone" />
                                <h3 className="animation-h3">Analytics & Reporting</h3>
                                <p className="description">
                                    Unlock the power of data with Analytics and Reporting - track performance,
                                    understand user behavior, and optimize strategies for real results.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="slide-content">
                        <div className="slide-bg-text">Growth Metrics</div>
                        <div className="content-wrapper">
                            <div className="content-inner">
                                {[...Array(9)].map((_, i) => (
                                    <img key={i} src={`./images/slide2-icon${i + 1}.png`} className={`icon slide2-${i + 1}`} alt="" />
                                ))}
                                <img src={process.env.PUBLIC_URL +"/images/phone-2.png"} alt="Phone" className="phone" />
                                <h3 className="animation-h3">Conversion Rate Optimization</h3>
                                <p className="description">
                                    Improve your conversion rates by analyzing user behavior and tailoring your
                                    digital experience to your audience.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Slide 3 */}
                    <div className="slide-content">
                        <div className="slide-bg-3" style={{ backgroundImage: "url('./images/slide3-bg.png')" }}></div>
                        <div className="content-wrapper">
                            <div className="content-inner">
                                {[...Array(6)].map((_, i) => (
                                    <img key={i} src={`./images/slide3-icon${i + 1}.png`} className={`icon slide3-${i + 1}`} alt="" />
                                ))}
                                <img src={process.env.PUBLIC_URL +"/images/phone.png"} alt="Phone" className="phone" />
                                <h3 className="animation-h3">Search Engine Optimization</h3>
                                <p className="description">
                                    Boost your website's visibility and rankings with SEO strategies designed for
                                    long-term success.
                                </p>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>

            <Getintouch />
            <Footer />
        </>
    )
}

export default Aboutleads